import { useTitle } from '@/lib/hooks';
import { Container, LinkButton } from '@/components/ui';

export default function NotFound() {
  useTitle('Page not found');
  return (
    <Container className="flex min-h-[60dvh] flex-col items-center justify-center py-20 text-center">
      <p className="text-7xl font-semibold text-gold/80">404</p>
      <h1 className="mt-4 font-display text-2xl tracking-wide">This path leads nowhere</h1>
      <p className="mt-2 max-w-md text-muted">The page you were looking for is not here. Maybe it teleported away.</p>
      <div className="mt-8 flex gap-3">
        <LinkButton to="/">Back to town</LinkButton>
        <LinkButton to="/news" variant="ghost">
          News
        </LinkButton>
      </div>
    </Container>
  );
}
